import script from "./MainLayout.vue?vue&type=script&setup=true&lang=js"
export * from "./MainLayout.vue?vue&type=script&setup=true&lang=js"

import "./MainLayout.vue?vue&type=style&index=0&id=27082c24&lang=css"
import "./MainLayout.vue?vue&type=style&index=1&id=27082c24&scoped=true&lang=css"
import "./MainLayout.vue?vue&type=style&index=2&id=27082c24&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-27082c24"]])

export default __exports__